export default __webpack_public_path__ + "static/media/BM.KHCN.03.03 Lý lịch khoa học.b5debc86.docx";